<div class="bv-error-container">
  <div class="bv-error-content">
    <h1 #bvErrorTitle class="iris-h1-responsive">{{ config.title }}</h1>
    <p class="iris-body-responsive">{{ formatSubtitle() }}</p>
    
    <ng-container [ngSwitch]="data?.errorType">
      
      <ng-container *ngSwitchCase="BvErrorTypes.SUGGESTED_PAYER">
        <p class="iris-body-responsive if-correct-text">
          If this looks correct, we'll check your coverage under this insurance.
        </p>
        
        <div *ngIf="showMemberDetails" class="what-we-found-section">
          <h4 class="iris-h4-responsive what-we-found-title">What we found</h4>
          
          <div class="suggested-insurance-container">
            <div class="insurance-label">Insurance</div>
            <div class="insurance-name-highlight">{{ suggestedInsuranceName }}</div>
            
            <div class="member-details-grid">
              <div class="member-detail-item">
                <div class="iris-body-responsive">Member name</div>
                <div class="iris-body-bold">{{ data?.memberName || '-' }}</div>
              </div>
              
              <div class="member-detail-item">
                <div class="iris-body-responsive">Date of birth</div>
                <div class="iris-body-bold">{{ data?.dateOfBirth || '-' }}</div>
              </div>
              
              <div class="member-detail-item">
                <div class="iris-body-responsive">Member ID</div>
                <div class="iris-body-bold">{{ data?.memberId || '-' }}</div>
              </div>
              
              <div class="member-detail-item">
                <div class="iris-body-responsive">Group number</div>
                <div class="iris-body-bold">{{ data?.groupNumber || '-' }}</div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>


      <ng-container *ngSwitchCase="BvErrorTypes.UNKNOWN_COSTSHARE">
        <p class="iris-body-responsive"><br>
          We're not yet able to provide a cost estimate for your plan but you can call your insurance company using the member services number on the back of your card to get details about the cost of your session.
        </p>
        
        <div class="unknown-costshare-icon-container">
          <img src="/assets/icons/unknown_cost_share.svg" alt="Insurance verification successful" class="unknown-costshare-icon" />
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="BvErrorTypes.MEDICAID_PLAN">
        <p class="iris-body-bold-responsive medicaid-plan-next-steps-title">Next steps we recommend:</p>
        
        <ul class="medicaid-plan-list">
          <li class="iris-body-responsive">
            Contact your Medicaid plan for a list of in-network providers who can meet your healthcare needs.
          </li>
        </ul>
      </ng-container>
      
      <ng-container *ngSwitchCase="BvErrorTypes.COVERAGE_NOT_STARTED">
        <p class="iris-body-bold-responsive what-you-can-do-title">What you can do:</p>
        
          <ul class="coverage-options-list">
          <li class="iris-body-responsive">
            Add a different insurance with active coverage that you can use instead
          </li>
          <li class="iris-body-responsive">
            Continue with self-pay rates for sessions
          </li>
          <li class="iris-body-responsive">
            Add this insurance to your account and use it for sessions <strong>after your plan start date</strong>
          </li>
          </ul>
      </ng-container>

      <ng-container *ngSwitchCase="BvErrorTypes.COVERAGE_EXPIRED">
        <p class="iris-body-responsive">
          If you have a current insurance plan, you can go back and enter it or you can continue with our self-pay rate for sessions.
        </p>
      </ng-container>
      
      <ng-container *ngSwitchCase="BvErrorTypes.NO_COVERAGE">
        <p class="iris-body-bold-responsive what-you-can-do-title">What you can do:</p>
        
        <ul class="coverage-options-list">
          <li class="iris-body-responsive">
            Call your insurance company using the number on the back of your card to verify if you have mental health coverage or if it's through a third-party
          </li>
          <li class="iris-body-responsive">
            Try a different insurance plan if you have other coverage available
          </li>
          <li class="iris-body-responsive">
            Continue with self-pay rates for sessions
          </li>
        </ul>
      </ng-container>
      
      <ng-container *ngSwitchDefault>
        <p class="iris-body-responsive if-correct-text">
          If this looks correct, we'll check your coverage under this insurance.
        </p>
      </ng-container>
      
    </ng-container>
  </div>

  <div class="bv-error-actions">
    <ng-container [ngSwitch]="data?.errorType">
      
      <!-- PAYOR_DOWNTIME: Single button layout -->
      <ng-container *ngSwitchCase="BvErrorTypes.PAYOR_DOWNTIME">
        <iris-button-container 
          [mobileLayout]="IrisButtonContainerMobileLayouts.FULLWIDTH"
          [desktopLayout]="IrisButtonContainerDesktopLayouts.FULLWIDTH">
          <iris-button
            [type]="IrisButtonTypes.PRIMARY"
            data-test="bv-error-primary-action"
            (click)="onPrimaryAction()"
          >
            {{ config.primaryButtonText }}
          </iris-button>
        </iris-button-container>
      </ng-container>

      <!-- COVERAGE_NOT_STARTED: Three button layout -->
      <ng-container *ngSwitchCase="BvErrorTypes.COVERAGE_NOT_STARTED">
        <iris-button-container 
          [mobileLayout]="IrisButtonContainerMobileLayouts.FULLWIDTH"
          [desktopLayout]="IrisButtonContainerDesktopLayouts.FULLWIDTH">
          <iris-button
            [type]="IrisButtonTypes.PRIMARY"
            data-test="bv-error-primary-action"
            (click)="onPrimaryAction()"
          >
            {{ config.primaryButtonText }}
          </iris-button>
        </iris-button-container>
        
        <iris-button-container 
          [mobileLayout]="IrisButtonContainerMobileLayouts.FULLWIDTH"
          [desktopLayout]="IrisButtonContainerDesktopLayouts.FULLWIDTH">
          <iris-button
            [type]="IrisButtonTypes.SECONDARY"
            data-test="bv-error-secondary-action"
            (click)="onSecondaryAction()"
          >
            {{ config.secondaryLinkText }}
          </iris-button>
        </iris-button-container>
        
        <iris-button-container 
          [mobileLayout]="IrisButtonContainerMobileLayouts.FULLWIDTH"
          [desktopLayout]="IrisButtonContainerDesktopLayouts.FULLWIDTH">
          <iris-button
            [type]="IrisButtonTypes.SECONDARY"
            data-test="bv-error-tertiary-action"
            (click)="onTertiaryAction()"
          >
            {{ config.tertiaryLinkText }}
          </iris-button>
        </iris-button-container>
      </ng-container>

      <!-- COVERAGE_EXPIRED: Three button layout -->
      <ng-container *ngSwitchCase="BvErrorTypes.COVERAGE_EXPIRED">
        <iris-button-container 
          [mobileLayout]="IrisButtonContainerMobileLayouts.FULLWIDTH"
          [desktopLayout]="IrisButtonContainerDesktopLayouts.FULLWIDTH">
      <iris-button
        [type]="IrisButtonTypes.PRIMARY"
        data-test="bv-error-primary-action"
        (click)="onPrimaryAction()"
      >
        {{ config.primaryButtonText }}
      </iris-button>
        </iris-button-container>
      
        <iris-button-container 
          [mobileLayout]="IrisButtonContainerMobileLayouts.FULLWIDTH"
          [desktopLayout]="IrisButtonContainerDesktopLayouts.FULLWIDTH">
      <iris-button
        [type]="IrisButtonTypes.SECONDARY"
        data-test="bv-error-secondary-action"
        (click)="onSecondaryAction()"
      >
        {{ config.secondaryLinkText }}
      </iris-button>
    </iris-button-container>
    
        <div class="tertiary-action-container">
          <iris-icon 
            class="info-icon" 
            name="info"
            colorToken="$color-neutral-60"
            [size]="IconSizes.SM">
          </iris-icon>
          <span class="tertiary-action-text">
            You can still
            <a 
              href="#" 
              class="tertiary-link" 
              data-test="bv-error-tertiary-action"
              (click)="onTertiaryAction(); $event.preventDefault()"
            >
              {{ config.tertiaryLinkText }}
            </a>
            but your sessions may not be covered. Our billing team will attempt to manually verify your insurance and reach out if they find out more information.
          </span>
        </div>
      </ng-container>

      <!-- NO_COVERAGE: Three button layout -->
      <ng-container *ngSwitchCase="BvErrorTypes.NO_COVERAGE">
        <iris-button-container 
          [mobileLayout]="IrisButtonContainerMobileLayouts.FULLWIDTH"
          [desktopLayout]="IrisButtonContainerDesktopLayouts.FULLWIDTH">
          <iris-button
            [type]="IrisButtonTypes.PRIMARY"
            data-test="bv-error-primary-action"
            (click)="onPrimaryAction()"
          >
            {{ config.primaryButtonText }}
          </iris-button>
        </iris-button-container>
        
        <iris-button-container 
          [mobileLayout]="IrisButtonContainerMobileLayouts.FULLWIDTH"
          [desktopLayout]="IrisButtonContainerDesktopLayouts.FULLWIDTH">
          <iris-button
            [type]="IrisButtonTypes.SECONDARY"
            data-test="bv-error-secondary-action"
            (click)="onSecondaryAction()"
          >
            {{ config.secondaryLinkText }}
          </iris-button>
        </iris-button-container>
        
        <div class="tertiary-action-container">
          <iris-icon 
            class="info-icon" 
            name="info"
            colorToken="$color-neutral-60"
            [size]="IconSizes.SM">
          </iris-icon>
          <span class="tertiary-action-text">
            You can still
            <a 
              href="#" 
              class="tertiary-link" 
              data-test="bv-error-tertiary-action"
              (click)="onTertiaryAction(); $event.preventDefault()"
            >
              {{ config.tertiaryLinkText }}
            </a>
            but your sessions may not be covered. Our billing team will attempt to manually verify your insurance and reach out if they find out more information.
          </span>
        </div>
      </ng-container>

      <!-- SUGGESTED_PAYER: Full width button layout -->
      <ng-container *ngSwitchCase="BvErrorTypes.SUGGESTED_PAYER">
        <iris-button-container 
          [mobileLayout]="IrisButtonContainerMobileLayouts.FULLWIDTH"
          [desktopLayout]="IrisButtonContainerDesktopLayouts.FULLWIDTH">
          <iris-button
            *ngIf="config.showPrimaryAction !== false"
            [type]="IrisButtonTypes.PRIMARY"
            data-test="bv-error-primary-action"
            (click)="onPrimaryAction()"
          >
            {{ config.primaryButtonText }}
          </iris-button>
        </iris-button-container>
        
        <div *ngIf="config.showSecondaryAction !== false && config.secondaryLinkText" class="secondary-action-container">
          <iris-icon 
            class="info-icon" 
            name="info"
            colorToken="$color-neutral-60"
            [size]="IconSizes.SM">
          </iris-icon>
          <span class="secondary-action-text">
            If this is not correct, you can
            <a 
              href="#" 
              class="secondary-link" 
              data-test="bv-error-secondary-action"
              (click)="onSecondaryAction(); $event.preventDefault()"
            >
              {{config.secondaryLinkText}}
            </a>
            but your sessions may not be covered. Our billing team will attempt to manually verify your insurance and reach out if they find out more information.
          </span>
        </div>
      </ng-container>

      <!-- MEDICAID_PLAN: Single button layout -->
      <ng-container *ngSwitchCase="BvErrorTypes.MEDICAID_PLAN">
        <iris-button-container 
          [mobileLayout]="IrisButtonContainerMobileLayouts.FULLWIDTH"
          [desktopLayout]="IrisButtonContainerDesktopLayouts.FULLWIDTH">
          <iris-button
            *ngIf="config.showPrimaryAction !== false"
            [type]="IrisButtonTypes.PRIMARY"
            data-test="bv-error-primary-action"
            (click)="onPrimaryAction()"
          >
            {{ config.primaryButtonText }}
          </iris-button>
        </iris-button-container>
      </ng-container>
      
      <!-- Default layout for other error types -->
      <ng-container *ngSwitchDefault>
        <iris-button-container [mobileLayout]="isMobile ? IrisButtonContainerMobileLayouts.FULLWIDTH : IrisButtonContainerMobileLayouts.SIDEBYSIDE">
          <iris-button
            *ngIf="config.showPrimaryAction !== false"
            [type]="IrisButtonTypes.PRIMARY"
            data-test="bv-error-primary-action"
            (click)="onPrimaryAction()"
          >
            {{ config.primaryButtonText }}
          </iris-button>
        </iris-button-container>
        
        <div *ngIf="config.showSecondaryAction !== false && config.secondaryLinkText" class="secondary-action-container">
      <iris-icon 
        class="info-icon" 
        name="info"
        colorToken="$color-neutral-60"
        [size]="IconSizes.SM">
      </iris-icon>
      <span class="secondary-action-text">
        <ng-container [ngSwitch]="data?.errorType">
              <ng-container *ngSwitchCase="BvErrorTypes.SUGGESTED_PAYER">
            If this is not correct, you can
            <a 
              href="#" 
              class="secondary-link" 
              data-test="bv-error-secondary-action"
              (click)="onSecondaryAction(); $event.preventDefault()"
            >
              {{config.secondaryLinkText}}
            </a>
            but your sessions may not be covered. Our billing team will attempt to manually verify your insurance and reach out if they find out more information.
          </ng-container>
          
          <ng-container *ngSwitchDefault>
            If this is not correct, you can
            <a 
              href="#" 
              class="secondary-link" 
              data-test="bv-error-secondary-action"
              (click)="onSecondaryAction(); $event.preventDefault()"
            >
              {{config.secondaryLinkText}}
            </a>
            but your sessions may not be covered. Our billing team will attempt to manually verify your insurance and reach out if they find out more information.
          </ng-container>
        </ng-container>
      </span>
    </div>
    
    <div *ngIf="config.showTertiaryAction && config.tertiaryLinkText" class="tertiary-action-container">
      <iris-icon 
        class="info-icon" 
        name="info"
        colorToken="$color-neutral-60"
        [size]="IconSizes.SM">
      </iris-icon>
      <span class="tertiary-action-text">
        You can still
        <a 
          href="#" 
          class="tertiary-link" 
          data-test="bv-error-tertiary-action"
          (click)="onTertiaryAction(); $event.preventDefault()"
        >
          {{config.tertiaryLinkText}}
        </a>
        but your sessions may not be covered. Our billing team will attempt to manually verify your insurance and reach out if they find out more information.
      </span>
    </div>
      </ng-container>
      
    </ng-container>
  </div>
</div> 